function computeStatus(status) {
  switch (status) {
  case 1:
    return "Open";
  case 2:
    return "Hiring";
  case 3:
    return "Closed";
  case 4:
    return "Ongoing";
  case 5:
    return "Archived";
  case 6:
    return "Completed";
  default:
    return "";
  }
}

function computeDuration(duration) {
  switch (duration) {
  case 1:
    return "1 month";
  case 2:
    return "3 months";
  case 3:
    return "6 months";
  case 4:
    return "Not Specified";
  default:
    return "Not Specified";
  }
}

function computeComplexity(complexity) {
  switch (complexity) {
  case 1:
    return "easy";
  case 2:
    return "medium";
  case 3:
    return "hard";
  default:
    return "not specified";
  }
}

function computeExperienceLevel(complexity) {
  switch (complexity) {
  case 1:
    return "junior";
  case 2:
    return "intermediate";
  case 3:
    return "senior";
  default:
    return "not specified";
  }
}

function computeCommitment(commitment) {
  switch (commitment) {
  case 1:
    return "hourly";
  case 2:
    return "daily";
  case 3:
    return "weekly";
  default:
    return "not specified";
  }
}

function computeLocation(location) {
  if (location) {
    return location;
  }
  return "not specified";
}

export {
  computeStatus,
  computeDuration,
  computeComplexity,
  computeCommitment,
  computeLocation,
  computeExperienceLevel
};
